import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "loading", "size", "children", "beforeIcon", "fullWidth"];
import * as React from 'react';
import cx from 'classnames';
import { getTheme } from '../../themes';
import { Spinner } from '../../../loader';
import * as customStyles from '../../styles/button.css';
import * as styles from '../../styles/shared.css';

/**
 * Компоненты кнопки. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать прелоадер, иконки и текст. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 */
var ButtonComponent = /*#__PURE__*/React.forwardRef(function Button(props, ref) {
  var _cx;
  var theme = props.theme,
    loading = props.loading,
    size = props.size,
    children = props.children,
    beforeIcon = props.beforeIcon,
    fullWidth = props.fullWidth,
    rest = _objectWithoutProperties(props, _excluded);
  var themeClasses = getTheme(theme);
  var buttonClasses = cx(styles['button'], customStyles['button'], styles[size], themeClasses['button'], (_cx = {}, _defineProperty(_cx, customStyles['loading'], loading), _defineProperty(_cx, styles['full-width'], fullWidth), _cx));
  return /*#__PURE__*/React.createElement("button", _extends({
    className: buttonClasses
  }, rest, {
    ref: ref
  }), loading && /*#__PURE__*/React.createElement("span", {
    className: cx(styles['spinner'], customStyles['spinner'], themeClasses['spinner'])
  }, /*#__PURE__*/React.createElement(Spinner, {
    color: "current_color",
    size: 16
  })), beforeIcon, children && /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, children));
});
ButtonComponent.defaultProps = {
  theme: 'fill_primary',
  size: 'M',
  loading: false,
  beforeIcon: undefined
};
export var Button = /*#__PURE__*/React.memo(ButtonComponent);